import React from 'react';

const StatTileSkeleton = () => (
  <div
    className='rounded-lg p-6 flex items-center justify-center gap-4 h-full'
    style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
  >
    <div className='skeleton w-12 h-12 rounded-lg' />
    <div>
      <div className='skeleton h-3.5 rounded w-24 mb-2' />
      <div className='skeleton h-5 rounded w-16' />
    </div>
  </div>
);

const StatsSectionSkeleton = () => {
  return (
    <div className='lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6'>
      <StatTileSkeleton />
      <StatTileSkeleton />
    </div>
  );
};

export default StatsSectionSkeleton;
